import { Environments } from 'contracts/enums';
import { API_BASE_URL_MAP, BASE_URL_MAP } from 'core/constants/baseUrls';

export const environment =
  BASE_URL_MAP[window.location.host] || Environments.local;
export const apiBaseURL = API_BASE_URL_MAP[environment];
